import React, {useState, useEffect} from "react";
import { Alert, ConfigProvider, Button } from "antd";
import { RecoilRoot } from "recoil";
import { IntlProvider } from "react-intl";
import { BrowserRouter as Router } from "react-router-dom";
import Entry from "./Entry";
import "../src/theme/index.scss";
import "./App.css";
//@ts-ignore
import Intercom from "@intercom/messenger-js-sdk";
import Honeypot from "app/shared/Honeypot";
import {useAnalytics} from "../src/hooks/useAnalytics";

// this for headless browser detection or scraper and bot restriction
const isHeadlessBrowser = (): boolean => {
  return (
    navigator.webdriver || // Puppeteer / headless Chrome
    /HeadlessChrome/.test(navigator.userAgent) ||
    /PhantomJS/.test(navigator.userAgent) ||
    /Nightmare/.test(navigator.userAgent)
  );
};

const AnalyticsTracker: React.FC = () => {
  useAnalytics(); // page view is tracked inside the hook
  return null;
};

const App: React.FC = () => {

  const [isBlocked, setIsBlocked] = useState(false);
  // const [overrideBlock, setOverrideBlock] = useState(false);

  useEffect(() => {
    if (isHeadlessBrowser()) {
      console.warn("🚨 Headless browser detected. Blocking access...");
      setIsBlocked(true); // keep your block page
    } else {
      Intercom({ app_id: "skt4rdsc" });
    }
  }, []);

  const defaultData = {
    colorPrimary: "#74003B",
  };
  // if (isBlocked && !overrideBlock)
  if (isBlocked ) {
    return (
      <div style={{ textAlign: "center", marginTop: "20vh" }}>
        <h2>🚫 Access Denied</h2>
        <p>Headless browsers are not allowed on this portal.</p>
        {/* <p>If you are a real user, click below to continue:</p> */}
        {/* <Button
          type="primary"
          onClick={() => {
            // setOverrideBlock(true);
            Intercom({ app_id: "skt4rdsc" }); // init Intercom after override
          }}
        >
          I’m a real user
        </Button> */}
      </div>
    );
  }


  // Intercom({
  //   app_id: "skt4rdsc",
  // });
  // const defaultData = {
  //   colorPrimary: "#74003B",
  // };
  return (
    <IntlProvider locale="en" defaultLocale="en">
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: defaultData.colorPrimary,
          },
        }}
      >
        <RecoilRoot>
          <Router>
            <Honeypot />
            <AnalyticsTracker />
            <Entry />
          </Router>
        </RecoilRoot>
      </ConfigProvider>
    </IntlProvider>
  );
};

export default App;
